import "./singlePost.css"

export default function SinglePost() {
  return (
    <div className="singlePost">
      <div className="singlePostWrapper">
        <img src="reactimg.jpg" alt="" className="singlePostimg" />
        <h1 className="singlePostTitle">Lorem ipsum dolor sit 
        <div className="singlePostedit">
        <i className="singlePostIcon fa-regular fa-pen-to-square"></i>
        <i className="singlePostIcon fa-solid fa-trash"></i>
        </div>
        </h1>
        <div className="singlePostInfo">
        <span className="singlePostAuthor">Autor: <b>Mandolorean</b> </span>
        <span className="singlePostDate">1 hour ago</span>
        </div>
        <p className="singlePostDesc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores laudantium, accusamus
             officia consectetur non voluptatum unde ipsa natus! Rem nisi, quasi alias i, quasi alias
             cumque accusantium itaque nesciunt! Rem nisi, quasi ! Rem nisi, quasi alias i, quasi alias
             alias quis sint cum ipsum.Lorem ipsum dolor sit amet ! Rem nisi, quasi alias i, quasi alias
             consectetur adipisicing elit. Asperiores laudantium, ! Rem nisi, quasi alias i, quasi alias
             accusamus officia consectetur non ! Rem nisi, quasi alias i, quasi alias i, quasi alias
             voluptatum unde ipsa natus cumque accusantium itaque nesciunti, quasi alias i, quasi alias
             quis sint cum ipsumofficia consectetur non voluptatum unde ipsa natus! Rem nis i, quasi alias
             cumque accusantium itaque nesciunt! Rem nisi, quasi ! Rem nisi, quasi alias i, quasi alias
             alias quis sint cum ipsum.Lorem ipsum dolor sit amet ! Rem nisi, quasi alias i, quasi alias
             consectetur adipisicing elit. Asperiores laudantium, ! Rem nisi, quasi alias i, quasi alias
             accusamus officia consectetur non ! Rem nisi, quasi alias i, quasi alias i, quasi alias
             voluptatum unde ipsa natus cumque accusantium itaque nesciunti, quasi alias i, quasi alias
             officia consectetur non voluptatum unde ipsa natus! Rem nisi, quasi alias i, quasi alias
             cumque accusantium itaque nesciunt! Rem nisi, quasi ! Rem nisi, quasi alias i, quasi alias
             alias quis sint cum ipsum.Lorem ipsum dolor sit amet ! Rem nisi, quasi alias i, quasi alias
             consectetur adipisicing elit. Asperiores laudantium, ! Rem nisi, quasi alias i, quasi alias
             accusamus officia consectetur non ! Rem nisi, quasi alias i, quasi alias i, quasi alias
             voluptatum unde ipsa natus cumque accusantium itaque nesciunt i, quasi alias i, quasi alias</p>
      </div>
    </div>
    
  )
}
